export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      service: "Notre service",
      process: "Processus",
      faq: "FAQ",
      contact: "Contact",
      openMenu: "Ouvrir le menu",
      closeMenu: "Fermer le menu",
      getQuote: "Devis gratuit",
      phone: "514-326-2246"
    },
    hero: {
      badge: "Spécialiste en restauration de baignoire",
      title: "Votre baignoire comme neuve",
      titleHighlight: "sans démolition",
      subtitle: "Restauration professionnelle sur place en 90 minutes. Économisez des milliers de dollars par rapport au remplacement.",
      cta: "Obtenir un devis gratuit",
      ctaSecondary: "Découvrir le processus",
      resultLabel: "Résultat garanti",
      resultText: "Comme neuve en 90 minutes.",
      trustBadge1: "Garantie jusqu’à 5 ans",
      trustBadgeLabel: "Sur nos travaux",
      trustBadge2: "Service rapide",
      trustBadge3: "Sans démolition"
    },
    whatIs: {
      sectionTag: "C'EST QUOI EXACTEMENT ?",
      title: "La restauration de baignoire expliquée simplement",
      description: "Le réémaillage (ou resurfaçage) est une technique professionnelle qui redonne à votre baignoire son éclat d'origine. Pas besoin de démolir votre salle de bain !",
      step1: {
        title: "Votre baignoire actuelle",
        desc: "Usée, tachée, rayée ou jaunissante avec le temps"
      },
      step2: {
        title: "Notre intervention",
        desc: "Nettoyage, préparation et application d'un nouveau revêtement"
      },
      step3: {
        title: "Résultat final",
        desc: "Une surface lisse, brillante et durable comme neuve"
      },
      comparison: {
        title: "Pourquoi choisir la restauration ?",
        replace: {
          title: "Remplacer la baignoire",
          items: [
            "Coût: 3 000$ à 8 000$+",
            "Délai: plusieurs jours à semaines",
            "Démolition et plomberie nécessaires",
            "Poussière et désordre dans la maison"
          ]
        },
        restore: {
          title: "Restaurer avec Éco-Bain",
          items: [
            "Coût: une fraction du prix",
            "Délai: 90 minutes seulement",
            "Aucune démolition requise",
            "Intervention propre, sans désordre"
          ]
        }
      }
    },
    services: {
      sectionTag: "NOS SERVICES",
      title: "Ce qu’on rénove, exactement",
      subtitle: "Une offre simple : baignoires, éviers et douches. Travail propre, résultat durable.",
      cards: [
        {
          title: "Baignoires",
          text: "Réémaillage de baignoires (fonte, tôle émaillée, acrylique), réparation locale d'acrylique et traitement antidérapant."
        },
        {
          title: "Lavabos et éviers",
          text: "Réémaillage de lavabos, éviers et cuves de lavage."
        },
        {
          title: "Douches et murs",
          text: "Rénovation de douches et réémaillage de céramique murale."
        }
      ],
      cta: "Demander un devis gratuit",
      learnMore: "Voir le service de réémaillage"
    },
    benefits: {
      sectionTag: "POURQUOI ÉCO-BAIN ?",
      title: "Ce qui nous distingue",
      items: [
        {
          icon: "piggyBank",
          title: "Économique",
          desc: "Jusqu'à 90 % d'économie par rapport au remplacement complet de votre baignoire."
        },
        {
          icon: "clock",
          title: "Rapide",
          desc: "Intervention complète en 90 minutes. Baignoire utilisable dès le lendemain."
        },
        {
          icon: "shield",
          title: "Durable",
          desc: "Garantie jusqu’à 5 ans sur tous nos travaux. Un investissement qui dure."
        },
        {
          icon: "leaf",
          title: "Écologique",
          desc: "Moins de déchets qu'un remplacement. Une solution responsable."
        }
      ]
    },
    faq: {
      sectionTag: "QUESTIONS FRÉQUENTES",
      title: "Vos questions, nos réponses",
      items: [
        {
          q: "Est-ce vraiment durable ?",
          a: "Oui ! Avec un entretien normal, votre baignoire restaurée durera de nombreuses années. C'est pourquoi nous offrons une garantie jusqu’à 5 ans sur tous nos travaux."
        },
        {
          q: "Est-ce que ça sent fort pendant les travaux ?",
          a: "Nous utilisons des produits professionnels avec une ventilation adéquate. L'odeur se dissipe rapidement après notre départ. Nous recommandons simplement d'aérer la pièce."
        },
        {
          q: "Quand puis-je réutiliser mon bain ?",
          a: "Votre baignoire sera prête à être utilisée dès le lendemain de notre intervention. Nous vous donnerons des instructions précises pour les premières 24 heures."
        },
        {
          q: "Est-ce vraiment moins cher que de remplacer ?",
          a: "Absolument. Un remplacement peut coûter entre 3 000$ et 8 000$ avec la plomberie et les travaux. Notre service coûte une fraction de ce prix, sans les inconvénients."
        },
        {
          q: "Quels types de baignoires traitez-vous ?",
          a: "Nous restaurons tous les types : fonte, acier, acrylique et fibre de verre. Chaque matériau reçoit un traitement adapté pour un résultat optimal."
        },
        {
          q: "Offrez-vous une garantie ?",
          a: "Les travaux de restauration de baignoires en fonte et en tôle émaillée sont couverts par une garantie de 5 ans.\nLes baignoires en acrylique ainsi que les lavabos sont couverts par une garantie de 1 an.\nLes conditions complètes sont indiquées sur la facture."
        }
      ]
    },
    testimonials: {
      sectionTag: "TÉMOIGNAGES",
      title: "Ce que nos clients disent",
      items: [
        {
          name: "Manon R.",
          location: "",
          text: "Wow! Maintenant ma baignoire à retrouver son lustre. Je peux enfin prendre mon bain! Il est resplendissant et facile à nettoyer. Je recommande à 100% et très bon prix.",
          rating: 5
        },
        {
          name: "Mathieu R.",
          location: "",
          text: "Super bon service et travaux pour mon bain!\nIl est comme un neuf! Prix très compétitif!",
          rating: 5
        },
        {
          name: "Jacques L.",
          location: "",
          text: "Je tiens à exprimer ma satisfaction envers votre compagnie qui a récemment réémaillé le bain de notre client. Leur travail a été exceptionnel, dépassant même nos attentes initiales.",
          rating: 5
        }
      ]
    },
    homeBeforeAfter: {
      sectionTag: "AVANT / APRÈS",
      title: "Découvrez le potentiel de votre espace bain avec l'IA Éco-Bain",
      description: "Faites glisser le curseur pour comparer une vraie photo avant restauration avec une simulation du résultat. Testez ensuite gratuitement votre propre photo avec notre aperçu IA.",
      cta: "Essayer l'aperçu IA gratuitement",
      sliderAlt: "Comparaison avant et après Éco-Bain",
      disclaimer: "Simulation visuelle générée par IA à titre indicatif. Un spécialiste Éco-Bain confirmera les options adaptées à votre projet."
    },
    form: {
      sectionTag: "CONTACTEZ-NOUS",
      title: "Demandez votre devis gratuit",
      subtitle: "Réponse rapide garantie. Décrivez votre projet et nous vous contacterons sous 24h.",
      name: "Votre nom",
      namePlaceholder: "Jean Tremblay",
      address: "Adresse des travaux",
      addressPlaceholder: "Commencez à taper votre adresse...",
      email: "Courriel",
      emailPlaceholder: "jean@exemple.com",
      phone: "Téléphone",
      phonePlaceholder: "(514) 555-1234",
      message: "Décrivez votre projet",
      messagePlaceholder: "Ma baignoire a des taches et des rayures...",
      photo: "Ajouter une photo",
      photoHint: "Ajoutez une photo si possible. Elle aide à préparer une estimation plus précise.",
      photoAdded: "Photo ajoutée",
      submit: "Envoyer ma demande",
      submitting: "Envoi en cours...",
      success: "Merci ! Votre demande a été envoyée. Nous vous contacterons sous peu.",
      error: "Une erreur est survenue. Veuillez réessayer ou nous appeler directement.",
      required: "Champs requis",
      aiPreviewPhotoRecovered: "Photo de l’aperçu IA optimisée et ajoutée au formulaire. Vous pouvez la retirer au besoin."
    },
    footer: {
      tagline: "Le spécialiste de la remise à neuf de baignoire au Québec.",
      serviceArea: "Zone de service",
      serviceAreaDesc: "Montréal et environs. Déplacement possible hors de l'île.",
      contact: "Contact",
      hours: "Heures d'ouverture",
      hoursDesc: "Lun-Ven: 9h-17h",
      copyright: "© 2026 Éco-Bain. Tous droits réservés."
    },
    aiPreview: {
      brandName: "Éco-Bain",
      badge: "Simulation de réémaillage par IA",
      title: "Aperçu IA Éco-Bain",
      subtitle: "Importez une photo réelle et visualisez une simulation photoréaliste du réémaillage.",
      uploader: {
        title: "Ajouter une photo",
        hint: "Une seule image, JPG/JPEG/PNG/WebP, maximum 10 MB.",
        choose: "Choisir une photo de votre espace bain",
        visibleTubHint: "Prenez l'ensemble de l'espace bain dans le cadrage, sans trop zoomer. L'aperçu fonctionne aussi si seule la baignoire est visible.",
        preparedFile: "Fichier préparé :",
        generate: "Visualiser le résultat",
        generating: "Création de votre aperçu…",
        generatingHint: "Gardez cette page ouverte. Le résultat s’affichera automatiquement.",
        previewAlt: "Aperçu avant génération"
      },
      loading: {
        title: "Simulation du réémaillage en cours",
        waitTime: "Génération en cours. Cela peut prendre environ 1 à 2 minutes.",
        didYouKnow: "Saviez-vous ?",
        facts: [
          "Le réémaillage permet jusqu'à 90 % d'économie par rapport à un remplacement complet.",
          "La majorité des projets sont réalisés en moins d'une journée.",
          "Éco-Bain permet de transformer votre salle de bain sans démolition majeure.",
          "Le meilleur rendu vient d'une photo claire où l'espace bain est bien visible.",
          "L'IA conserve le cadrage original pour comparer le résultat plus facilement.",
          "Vous pourrez joindre votre photo optimisée à votre demande d'estimation."
        ]
      },
      empty: {
        title: "Visualisez le potentiel de votre espace bain.",
        text: "Ajoutez une photo claire de votre espace bain pour découvrir une simulation de remise à neuf."
      },
      result: {
        regionLabel: "Votre aperçu généré",
        conversionTitle: "Vous aimez le résultat ?",
        conversionText: "Recevez une estimation gratuite en moins de 24 heures. Votre photo optimisée sera ajoutée à votre demande.",
        note: "Cet aperçu est une simulation visuelle générée par IA. Un spécialiste Éco-Bain confirmera les options adaptées à votre projet.",
        alt: "Simulation Éco-Bain",
        retry: "Réessayer avec une autre photo",
        cta: "Obtenir une estimation gratuite",
        disclaimer: "Le résultat est une simulation visuelle. Un spécialiste Éco-Bain confirmera les options possibles selon l'état réel de la surface."
      },
      slider: {
        before: "Avant",
        after: "Après",
        label: "Comparer avant et après"
      },
      errors: {
        missingImage: "Ajoutez une image JPG, JPEG ou PNG.",
        unsupportedFormat: "Format non supporté. Utilisez JPG, JPEG ou PNG.",
        uploadTooLarge: "Image trop lourde. La limite est de 10 MB.",
        apiTooLarge: "L'image est trop lourde après optimisation. Essaie une photo plus légère ou recadre-la.",
        generationFailed: "La génération a échoué. Réessayez avec une photo plus claire.",
        rateLimited: "La limite de générations est atteinte pour aujourd'hui. Vous pouvez quand même demander une estimation gratuite.",
        generationUnknown: "Une erreur est survenue pendant la génération."
      }
    }
    ,
    pages: {
      listedepirx: {
        title: "Liste de prix",
        sections: [
          {
            id: "baignoires-tole-fonte",
            heading: "Baignoires (Tôle et fonte)",
            rows: [
              { service: "- Réémaillage d'une baignoire encastré en fonte et en tôle émaillé", price: "345$" },
              { service: "- Baignoire sur pattes intérieur (Fonte)", price: "345$" },
              { service: "- Remplissage des trous de robinet pour l'installation d'une robinetterie externe", price: "50$" },
              { service: "- Supplément pour les baignoires étant réémaillé auparavant.", price: "90$ à 120$" },
              { service: "- Supplément pour les baignoires étant très abimé dans le fonds,", note: "soit par un tapis de bain ou des antidérapants en forme de fleurs soit par un acide pour le drain.", price: "80$ à 120$" },
              { service: "- Supplément pour changement de couleur (Couche supplémentaire)", price: "40$" }
            ]
          },
          {
            id: "baignoires-acrylique",
            heading: "Baignoires en acrilique",
            rows: [
              { service: "- Rénovation de bain acrylique une place", price: "425$" },
              { service: "- Rénovation bain tourbillon une place", price: "450$ à 480$" },
              { service: "- Réparation local de fissure et bris de baignoire et douche en acrylique", price: "225$ à 340$" },
              { service: "- Polissage d'une baignoire en acrylique", price: "180$ à 280$" }
            ]
          },
          {
            id: "baignoires-sur-dimensionnes",
            heading: "Baignoires sur-dimensionnés",
            rows: [
              { service: "Baignoires thérapeutiques et tourbillons de différentes formes", price: "480$ à 1800$" }
            ]
          },
          {
            id: "extraction-coquille",
            heading: "Extraction d'une coquille rigide",
            rows: [
              { service: "- Extraction d'une coquille rigide, nettoyage de la colle et le réémaillage de la baignoire d'origine.", price: "950$ à 1200$" }
            ]
          },
          {
            id: "ceramique-accessoires",
            heading: "Céramique et accessoires",
            rows: [
              { service: "- Réémaillage de la céramique", price: "10$ pi/2" },
              { service: "- Réémaillage des accessoires", note: "Ex : porte savon, porte serviette et distributeur de papier hygiénique", price: "15$ à 25$ / l’unité" }
            ]
          },
          {
            id: "douche-base",
            heading: "Douche et base de douche",
            rows: [
              { service: "- Base", price: "345$" },
              { service: "- Cabine de douche", price: "450$ à 650$" }
            ]
          },
          {
            id: "evier",
            heading: "Réémaillage d'éviers en fonte ou en tôle émaillé",
            rows: [
              { service: "- Simple cuve", price: "385$" },
              { service: "- Simple cuve avec un égouttoir", price: "425$" },
              { service: "- Double cuve", price: "450$ à 485$" },
              { service: "- Supplément de 90$ à 120$ pour les éviers étant réémaillé auparavant.", price: "" }
            ]
          },
          {
            id: "frais-deplacement",
            heading: "Frais de déplacement",
            rows: [
              { service: "- Zone 1 : montant fixe de 25$", note: "(environs immédiats de Montréal : Longueuil, Brossard, Boucherville, Repentigny, Laval)", price: "" },
              { service: "- Zones 2 et 3 : 1 $ / km", note: "facturé à partir de nos bureaux à Montréal (H1B4T2)", price: "" }
            ]
          }
        ]
      },
      aSavoir: {
        title: "À savoir",
        intro: "Quelques informations importantes pour assurer un résultat optimal lors du resurfaçage.",
        items: [
          "Le processus de resurfaçage demande un environnement avec le moins de poussière possible pour un résultat optimal.",
          "Nous avons besoin d’eau chaude et d’eau froide pour plusieurs rinçages (drain fonctionnel requis).",
          "La température ambiante idéale dans la salle de bain doit se situer entre 18°C et 25°C."
        ]
      },
      avisAuxUtilisateurs: {
        title: "Avis aux clients",
        lines: [
          "Important : notre procédé de séchage ne nécessite pas de lampe infrarouge, ce qui élimine le risque d’incendie."
        ]
      }
      ,
      // New structured keys (kept alongside legacy keys for backward compatibility)
      asavoir: {
        title: "À savoir",
        subtitle: "Liste des points importants à prendre en compte pour votre émaillage.",
        items: [
          "Assurez-vous que l’eau froide et chaude est accessible et que le drain fonctionne normalement.",
          "La température ambiante de la pièce doit être maintenue entre 18 et 28 degrés.",
          "Avant notre intervention, veuillez vider la salle de bain, enlever les rideaux de douche et laver le plancher.",
          "Il est recommandé d’avoir un environnement propre et sans poussière à l’intérieur et à l’extérieur de la salle de bain. Notre système de ventilation crée une pression négative dans la pièce, ce qui peut entraîner l’entrée d’air provenant d’autres pièces. Pour obtenir un fini parfait, il est préférable que notre intervention soit effectuée en dernier sur le chantier.",
          "Si vous envisagez de remplacer le drain, nous vous recommandons de le faire avant notre intervention, car des frais supplémentaires seront facturés en cas d’extraction du drain. Cependant, dans notre procédé habituel, il n’est généralement pas nécessaire d’extraire le drain.",
          "Un accès à une fenêtre à l’extérieur de la salle de bain pour sortir notre système de ventilation.",
          "Pour les robinetteries des baignoires sur pied, il peut parfois être nécessaire de les extraire. Dans ce cas, nous exigeons la présence de valves permettant de fermer l’eau lors de l’extraction.",
          {
            title: "Des frais supplémentaires peuvent s’appliquer dans les situations suivantes :",
            subitems: [
              "Extraction de la porte de douche et décontamination de la colle sur la baignoire.",
              "Reconstruction du fond de la baignoire due à une usure irrégulière majeure causée par un tapis de bain, des collants antidérapants ou des débouche-tuyaux puissants qui ont endommagé la surface.",
              "Rouille excessive autour du drain.",
              "Dimensions de la salle de bain dépassant les normes habituelles."
            ]
          }
        ],
        cancellation: "Nous vous rappelons qu’en cas d’annulation, nous demandons un préavis de 24 heures. Dans le cas contraire, des frais d’annulation seront appliqués."
      },
      avis: {
        title: "Avis aux utilisateurs",
        subtitle: "Attendre 24h avant l’utilisation de vos sanitaires.",
        items: [
          "Ne jamais utiliser d’antidérapant avec succions (tapis de bain).",
          "Ne pas placer des contenants ou savon sur le bord de votre baignoire.",
          "Toujours diluer dans un contenant avec de l’eau l’huile, sel ou mousse de bain.",
          "Ne jamais nettoyer les stores ou autres objets qui peuvent abîmer votre baignoire.",
          "Ne jamais laisser tremper quoi que ce soit à l’eau de javel ou autres détergents forts.",
          "Aviser le propriétaire ou la personne responsable le plus tôt possible si vos robinets coulent.",
          "Nettoyer votre nouvelle baignoire avec un savon liquide tel que Biovert, Bionature ou simplement du savon à vaisselle."
        ]
      }
    }
  },
  en: {
    nav: {
      home: "Home",
      service: "Our Service",
      process: "Process",
      faq: "FAQ",
      contact: "Contact",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      getQuote: "Free Quote",
      phone: "514-326-2246"
    },
    hero: {
      badge: "Bathtub Restoration Specialist",
      title: "Your bathtub like new",
      titleHighlight: "without demolition",
      subtitle: "Professional on-site restoration in 90 minutes. Save thousands compared to replacement.",
      cta: "Get a Free Quote",
      ctaSecondary: "Discover the Process",
      resultLabel: "Guaranteed result",
      resultText: "Like new in 90 minutes.",
      trustBadge1: "Warranty up to 5 years",
      trustBadgeLabel: "On our work",
      trustBadge2: "Fast Service",
      trustBadge3: "No Demolition"
    },
    whatIs: {
      sectionTag: "WHAT IS IT EXACTLY?",
      title: "Bathtub restoration explained simply",
      description: "Reglazing (or resurfacing) is a professional technique that restores your bathtub to its original shine. No need to demolish your bathroom!",
      step1: {
        title: "Your current bathtub",
        desc: "Worn, stained, scratched or yellowed over time"
      },
      step2: {
        title: "Our intervention",
        desc: "Cleaning, preparation and application of a new coating"
      },
      step3: {
        title: "Final result",
        desc: "A smooth, shiny and durable surface like new"
      },
      comparison: {
        title: "Why choose restoration?",
        replace: {
          title: "Replace the bathtub",
          items: [
            "Cost: $3,000 to $8,000+",
            "Time: several days to weeks",
            "Demolition and plumbing required",
            "Dust and mess in the house"
          ]
        },
        restore: {
          title: "Restore with Éco-Bain",
          items: [
            "Cost: a fraction of the price",
            "Time: 90 minutes only",
            "No demolition required",
            "Clean intervention, no mess"
          ]
        }
      }
    },
    services: {
      sectionTag: "OUR SERVICES",
      title: "What we refinish, exactly",
      subtitle: "A simple offer: bathtubs, sinks and showers. Clean work, durable results.",
      cards: [
        {
          title: "Bathtubs",
          text: "Bathtub refinishing (cast iron, enameled steel, acrylic), local acrylic repairs and anti-slip treatment."
        },
        {
          title: "Sinks and basins",
          text: "Refinishing for bathroom sinks, kitchen sinks and laundry tubs."
        },
        {
          title: "Showers and walls",
          text: "Shower renovation and wall-tile refinishing."
        }
      ],
      cta: "Request a free quote",
      learnMore: "View the reglazing service"
    },
    benefits: {
      sectionTag: "WHY ECO-BAIN?",
      title: "What sets us apart",
      items: [
        {
          icon: "piggyBank",
          title: "Affordable",
          desc: "Up to 90% savings compared to complete bathtub replacement."
        },
        {
          icon: "clock",
          title: "Fast",
          desc: "Complete intervention in 90 minutes. Bathtub ready the next day."
        },
        {
          icon: "shield",
          title: "Durable",
          desc: "Warranty up to 5 years on all our work. An investment that lasts."
        },
        {
          icon: "leaf",
          title: "Eco-friendly",
          desc: "Less waste than replacement. A responsible solution."
        }
      ]
    },
    faq: {
      sectionTag: "FREQUENTLY ASKED QUESTIONS",
      title: "Your questions, our answers",
      items: [
        {
          q: "Is it really durable?",
          a: "Yes! With normal maintenance, your restored bathtub will last many years. That's why we offer a warranty up to 5 years on all our work."
        },
        {
          q: "Does it smell strong during the work?",
          a: "We use professional products with adequate ventilation. The odor dissipates quickly after we leave. We simply recommend ventilating the room."
        },
        {
          q: "When can I use my bath again?",
          a: "Your bathtub will be ready to use the day after our intervention. We will give you precise instructions for the first 24 hours."
        },
        {
          q: "Is it really cheaper than replacing?",
          a: "Absolutely. A replacement can cost between $3,000 and $8,000 with plumbing and work. Our service costs a fraction of that price, without the inconveniences."
        },
        {
          q: "What types of bathtubs do you treat?",
          a: "We restore all types: cast iron, steel, acrylic and fiberglass. Each material receives an adapted treatment for optimal results."
        },
        {
          q: "Do you offer a warranty?",
          a: "Refinishing work on cast iron and enameled steel bathtubs is covered by a 5-year warranty.\nAcrylic bathtubs and sinks are covered by a 1-year warranty.\nFull warranty conditions are detailed on the invoice."
        }
      ]
    },
    testimonials: {
      sectionTag: "TESTIMONIALS",
      title: "What our clients say",
      items: [
        {
          name: "Manon R.",
          location: "",
          text: "Wow! My bathtub has regained its shine. I can finally take a bath! It's radiant and easy to clean. I recommend them 100% — great price.",
          rating: 5
        },
        {
          name: "Mathieu R.",
          location: "",
          text: "Great service and work on my tub! It looks like new! Very competitive price!",
          rating: 5
        },
        {
          name: "Jacques L.",
          location: "",
          text: "I want to express my satisfaction with your company, which recently reglazed our client's bathtub. Their work was exceptional, even exceeding our initial expectations.",
          rating: 5
        }
      ]
    },
    homeBeforeAfter: {
      sectionTag: "BEFORE / AFTER",
      title: "Discover the potential of your bath area with Éco-Bain AI",
      description: "Drag the slider to compare a real photo before restoration with a simulation of the result. Then try your own photo free with our AI preview.",
      cta: "Try the AI preview free",
      sliderAlt: "Éco-Bain before and after comparison",
      disclaimer: "AI-generated visual simulation for reference only. An Éco-Bain specialist will confirm the options suited to your project."
    },
    form: {
      sectionTag: "CONTACT US",
      title: "Request your free quote",
      subtitle: "Fast response guaranteed. Describe your project and we'll contact you within 24 hours.",
      name: "Your name",
      namePlaceholder: "John Smith",
      address: "Work address",
      addressPlaceholder: "Start typing your address...",
      email: "Email",
      emailPlaceholder: "john@example.com",
      phone: "Phone",
      phonePlaceholder: "(514) 555-1234",
      message: "Describe your project",
      messagePlaceholder: "My bathtub has stains and scratches...",
      photo: "Add a photo",
      photoHint: "Add a photo if possible. It helps us prepare a more accurate estimate.",
      photoAdded: "Photo added",
      submit: "Send my request",
      submitting: "Sending...",
      success: "Thank you! Your request has been sent. We will contact you shortly.",
      error: "An error occurred. Please try again or call us directly.",
      required: "Required fields",
      aiPreviewPhotoRecovered: "Optimized AI preview photo added to the form. You can remove it if needed."
    },
    footer: {
      tagline: "The bathtub restoration specialist in Quebec.",
      serviceArea: "Service Area",
      serviceAreaDesc: "Montreal and surroundings. Travel possible off the island.",
      contact: "Contact",
      hours: "Business Hours",
      hoursDesc: "Mon-Fri: 9am-5pm",
      copyright: "© 2026 Éco-Bain. All rights reserved."
    },
    aiPreview: {
      brandName: "Éco-Bain",
      badge: "AI reglazing simulation",
      title: "Éco-Bain AI Preview",
      subtitle: "Upload a real photo and preview a photorealistic reglazing simulation.",
      uploader: {
        title: "Add a photo",
        hint: "One image only, JPG/JPEG/PNG/WebP, maximum 10 MB.",
        choose: "Choose a photo of your bath area",
        visibleTubHint: "Frame the full bath area without zooming too tightly. The preview also works when only the bathtub is visible.",
        preparedFile: "Prepared file:",
        generate: "Preview the result",
        generating: "Creating your preview…",
        generatingHint: "Keep this page open. Your result will appear automatically.",
        previewAlt: "Preview before generation"
      },
      loading: {
        title: "Reglazing simulation in progress",
        waitTime: "Generation in progress. This can take about 1 to 2 minutes.",
        didYouKnow: "Did you know?",
        facts: [
          "Reglazing offers up to 90% savings compared to a full replacement.",
          "Most projects are completed in less than a day.",
          "Éco-Bain can transform your bathroom without major demolition.",
          "The best preview comes from a clear photo where the bath area is easy to see.",
          "The AI keeps the original framing so the comparison feels natural.",
          "You can send your optimized photo with your estimate request."
        ]
      },
      empty: {
        title: "Preview the potential of your bath area.",
        text: "Add a clear photo of your bath area to discover a refinishing simulation."
      },
      result: {
        regionLabel: "Your generated preview",
        conversionTitle: "Like the result?",
        conversionText: "Receive a free estimate in less than 24 hours. Your optimized photo will be added to your request.",
        note: "This preview is an AI-generated visual simulation. An Éco-Bain specialist will confirm the options suited to your project.",
        alt: "Éco-Bain simulation",
        retry: "Try another photo",
        cta: "Get a free estimate",
        disclaimer: "The result is a visual simulation. An Éco-Bain specialist will confirm the possible options based on the real condition of the surface."
      },
      slider: {
        before: "Before",
        after: "After",
        label: "Compare before and after"
      },
      errors: {
        missingImage: "Add a JPG, JPEG, or PNG image.",
        unsupportedFormat: "Unsupported format. Use JPG, JPEG, or PNG.",
        uploadTooLarge: "Image too large. The limit is 10 MB.",
        apiTooLarge: "The image is still too large after optimization. Try a lighter photo or crop it.",
        generationFailed: "Generation failed. Try again with a clearer photo.",
        rateLimited: "The generation limit has been reached for today. You can still request a free estimate.",
        generationUnknown: "An error occurred during generation."
      }
    }
    ,
    pages: {
      listedepirx: {
        title: "Price List",
        sections: [
          {
            id: "baignoires-tole-fonte",
            heading: "Bathtubs (Steel & Cast Iron)",
            rows: [
              { service: "- Refinishing of a built-in bathtub (cast iron or enameled steel)", price: "$345" },
              { service: "- Clawfoot bathtub (interior only, cast iron)", price: "$345" },
              { service: "- Filling faucet holes for external fixture installation", price: "$50" },
              { service: "- Surcharge for bathtubs previously refinished", price: "$90 to $120" },
              { service: "- Surcharge for heavily damaged tub bottoms (bath mat, flower-shaped anti-slip pads, or drain acid)", price: "$80 to $120" },
              { service: "- Color change surcharge (additional coat)", price: "$40" }
            ]
          },
          {
            id: "baignoires-acrylique",
            heading: "Acrylic Bathtubs",
            rows: [
              { service: "- Single acrylic bathtub renovation", price: "$425" },
              { service: "- Single whirlpool bathtub renovation", price: "$450 to $480" },
              { service: "- Local repair of cracks/damage (acrylic tub and shower)", price: "$225 to $340" },
              { service: "- Acrylic bathtub polishing", price: "$180 to $280" }
            ]
          },
          {
            id: "baignoires-sur-dimensionnes",
            heading: "Oversized Bathtubs",
            rows: [
              { service: "Therapeutic bathtubs and whirlpools of various shapes", price: "$480 to $1,800" }
            ]
          },
          {
            id: "extraction-coquille",
            heading: "Rigid Shell Removal",
            rows: [
              { service: "- Rigid shell removal, glue cleanup, and refinishing of the original bathtub.", price: "$950 to $1,200" }
            ]
          },
          {
            id: "ceramique-accessoires",
            heading: "Ceramic and Accessories",
            rows: [
              { service: "- Ceramic refinishing", price: "$10 / sq.ft" },
              { service: "- Accessory refinishing (soap dish, towel bar, toilet paper holder)", price: "$15 to $25 / unit" }
            ]
          },
          {
            id: "douche-base",
            heading: "Shower and Shower Base",
            rows: [
              { service: "- Shower base", price: "$345" },
              { service: "- Shower cabin", price: "$450 to $650" }
            ]
          },
          {
            id: "evier",
            heading: "Refinishing of Cast Iron or Enameled Steel Sinks",
            rows: [
              { service: "- Single bowl", price: "$385" },
              { service: "- Single bowl with drainboard", price: "$425" },
              { service: "- Double bowl", price: "$450 to $485" },
              { service: "- Surcharge of $90 to $120 for sinks previously refinished", price: "" }
            ]
          },
          {
            id: "frais-deplacement",
            heading: "Travel Fees",
            rows: [
              { service: "- Zone 1: flat fee of 25$", note: "(Montreal area: Longueuil, Brossard, Boucherville, Repentigny, Laval)", price: "" },
              { service: "- Zones 2 and 3: $1/km", note: "billed from our Montreal office (H1B4T2)", price: "" }
            ]
          }
        ]
      },
      aSavoir: {
        title: "To know",
        intro: "Key information to ensure optimal results during the resurfacing process.",
        items: [
          "The resurfacing process requires minimal surrounding dust for optimal results.",
          "We require both cold and hot water for multiple rinses (functional drain required).",
          "An ambient temperature between 18°C and 25°C (in the bathroom)."
        ]
      },

      avisAuxUtilisateurs: {
        title: "Customer notice",
        lines: [
          "Important: our drying process does not require an infrared heat lamp, eliminating the risk of fire."
        ]
      }
      ,
      // New structured keys (English parity)
      asavoir: {
        title: "Important information",
        subtitle: "Key points to consider for your reglazing.",
        items: [
          "Ensure both cold and hot water are accessible and that the drain functions normally.",
          "Maintain an ambient room temperature between 18°C and 28°C.",
          "Before our visit, please clear the bathroom, remove shower curtains, and clean the floor.",
          "We recommend a clean, dust-free environment inside and outside the bathroom. Our ventilation system creates negative pressure in the room which can draw air from adjacent spaces. For a perfect finish, it is preferable that our work be performed last on the site.",
          "If you plan to replace the drain, we advise doing so before our intervention, as additional charges may apply if the drain must be removed. In our usual process, removal is generally not necessary.",
          "Access to an exterior window for our ventilation exhaust is required.",
          "For clawfoot bathtub fixtures, removal may sometimes be necessary. In that case, shut-off valves must be available to stop the water during removal.",
          {
            title: "Additional charges may apply in the following situations:",
            subitems: [
              "Removal of the shower door and decontamination of glue from the bathtub.",
              "Reconstruction of the tub bottom due to severe irregular wear caused by bath mats, anti-slip inserts, or aggressive drain cleaners that have damaged the surface.",
              "Excessive rust around the drain.",
              "Bathroom dimensions exceeding standard sizes."
            ]
          }
        ],
        cancellation: "Please note: cancellations require at least 24 hours' notice. Otherwise, cancellation fees may apply."
      },
      avis: {
        title: "User notice",
        subtitle: "Wait 24 hours before using your sanitary fixtures.",
        items: [
          "Never use suction-type anti-slip bath mats.",
          "Do not place containers or soap on the edge of your bathtub.",
          "Always dilute oils, salts or bath foams in a container with water before use.",
          "Never clean blinds or other items that could damage your bathtub.",
          "Never soak anything in bleach or other strong detergents.",
          "Notify the owner or responsible person as soon as possible if your taps leak.",
          "Clean your new bathtub with a liquid soap such as Biovert, Bionature or simply dish soap."
          ]
        }
    }
  }
};
